import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

export const uploadMultiImage = (data, config) => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.upload}`, data, config);
export const uploadMultiImageAsset = (data, config) => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.uploadAssetImage}`, data, config);
export const uploadMultiImageNormalAsset = (data, config) =>
    fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.uploadNormalAssetImage}`, data, config);
export const uploadThreeSixtyImages = (data, config) =>
    fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.uploadThreeSixtyImages}`, data, config);
export const updateImage = (data, id, section) =>
    section === "mobile_recommendations"
        ? fcaFastApi.put(`${serviceEndpoints.imageEndPoints.mobileRecomImageupdate}${id}`, data)
        : fcaGateWay.patch(`${serviceEndpoints.imageEndPoints.update}`, data);
export const updateImageGlobally = data => fcaGateWay.patch(`${serviceEndpoints.imageEndPoints.updateGlobally}`, data);

export const checkDuplicateImages = data =>
    isEnabled("migrate_report_config")
        ? fcaFastApi.post(`${serviceEndpoints.imageEndPoints.checkDuplicateFastApi}`, data)
        : fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.checkDuplicate}`, data);
export const checkDuplicateImagesAsset = data => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.checkDuplicateAsset}`, data);
export const checkDuplicateImagesNormalAsset = data => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.checkDuplicateNormalAsset}`, data);

//Get dropdowns
export const getProjectList = params => fcaGateWay.get(`${serviceEndpoints.imageEndPoints.projectList}`, { params });
export const getBuildingList = params =>
    fcaGateWay.get(`${serviceEndpoints.imageEndPoints.buildingList}`, { params: { project_id: params.project_id } });
export const getTradeList = params =>
    fcaGateWay.get(`${serviceEndpoints.imageEndPoints.tradeList}/${params.project_id}/trades_dropdown`, {
        params: { project_id: params.project_id }
    });
export const getSystemList = params =>
    fcaGateWay.get(`${serviceEndpoints.imageEndPoints.systemList}/${params.project_id}/systems_dropdown`, {
        params: { project_id: params.project_id, trade_id: params.trade_id }
    });
export const getSubsystemList = params =>
    fcaGateWay.get(`${serviceEndpoints.imageEndPoints.subsystemList}/${params.project_id}/sub_systems_dropdown`, { params });

export const getAllImages = params =>
    (isEnabled("migrate_images_list") ? fcaFastApi : fcaGateWay).get(`${serviceEndpoints.imageEndPoints.allImages}`, { params });
export const getFilterLists = (key, params, id, isMobileAsset, isInaccessible, section) =>
    !isMobileAsset && !isInaccessible
        ? fcaGateWay.get(`${serviceEndpoints.imageEndPoints.filterLists[key]}`, { params })
        : section === "client_standards"
        ? fcaGateWay.get(`${serviceEndpoints.assetManagementEndpoints.clientStandard}/${id}/master_images_get_list`, {
              params: { ...params, field: key === "labels" ? "image_tag" : key }
          })
        : section === "uniformat_level_6s"
        ? fcaGateWay.get(`${serviceEndpoints.assetManagementEndpoints.uniformat6}/${id}/master_images_get_list`, {
              params: { ...params, field: key === "labels" ? "image_tag" : key }
          })
        : section === "uniformat_level_5s"
        ? fcaGateWay.get(`${serviceEndpoints.assetManagementEndpoints.uniformat5}/${id}/master_images_get_list`, {
              params: { ...params, field: key === "labels" ? "image_tag" : key }
          })
        : section === "mobile_recommendations"
        ? fcaGateWay.get(`${serviceEndpoints.assetManagementEndpoints.image_list}${section}/${id}/master_images_get_list`, {
              params: { ...params, field: key === "labels" ? "image_tag" : key }
          })
        : !isInaccessible
        ? fcaGateWay.get(`${serviceEndpoints.assetManagementEndpoints.mobileMasterFilters}/${id}/master_images_get_list`, {
              params: { ...params, field: key === "labels" ? "image_tag" : key }
          })
        : fcaGateWay.get(`${serviceEndpoints.assetManagementEndpoints.mobileInaccessibleMasterFilters}/${id}/master_images_get_list`, {
              params: { ...params, field: key === "labels" ? "image_tag" : key }
          });

export const getAllImagesByRecommendation = (params, id) =>
    fcaGateWay.get(`${serviceEndpoints.imageEndPoints.getImagesByRecommendations}/${id}/master_images`, { params });

export const getAllImagesBySection = (params, id, section) =>
    fcaGateWay.get(`${serviceEndpoints.imageEndPoints.getAllImagesBySection}/${section}/${id}/master_images`, { params });

export const assignImagesToSection = (data, id, section) =>
    section === "adc-asset-image"
        ? fcaFastApi.post(`${serviceEndpoints.imageEndPoints.getAllImagesBySection}/${section}/`, data)
        : section === "client-standards-images" || section === "uniformat-standard_images"
        ? fcaFastApi.post(`${serviceEndpoints.imageEndPoints.getAllImagesBySection}/${section}/create/`, data)
        : section === "mobile-recom-image"
        ? fcaFastApi.post(`${serviceEndpoints.imageEndPoints.getAllImagesBySection}/${section}/`, data)
        : fcaGateWay.post(`${serviceEndpoints.imageEndPoints.getAllImagesBySection}/${section}/${id}/assign_master_images`, data);

export const getAllImagesByNarrative = params => fcaGateWay.get(`${serviceEndpoints.imageEndPoints.getImagesByNarrative}`, { params });
export const checkImageMapped = id =>
    (isEnabled("migrate_images_list") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.imageEndPoints.checkImageMapped}/${id}/mapped_to_recommendation`
    );
export const deleteImage = params =>
    (isEnabled("migrate_images_list") ? fcaFastApi : fcaGateWay).delete(`${serviceEndpoints.imageEndPoints.deleteImage}`, { params });
export const addToFav = params =>
    (isEnabled("migrate_images_list") ? fcaFastApi : fcaGateWay).patch(`${serviceEndpoints.imageEndPoints.addToFav}`, params);
export const getUserDefaultTrade = id => fcaGateWay.get(`${serviceEndpoints.imageEndPoints.getUserDefaultTrade}/${id}/trades/user_trade`);
export const getImageLogs = params =>
    isEnabled("migrate_report_config")
        ? fcaFastApi.get(`${serviceEndpoints.imageEndPoints.imageLogsFastApi}`, { params })
        : fcaReportGateway.get(`${serviceEndpoints.imageEndPoints.imageLogs}`, { params });
export const getSelectedProject = id => fcaGateWay.get(`${serviceEndpoints.imageEndPoints.getSelectedProject}/${id}`);
export const getLabelList = params => fcaGateWay.get(`${serviceEndpoints.imageEndPoints.getAllLabels}`, { params });
//export images
export const exportImages = params => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.export}`, params, { responseType: "blob" });
export const exportImagesPdf = params => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.exportPdf}`, params, { responseType: "blob" });
export const exportImagesZip = params => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.exportAsZip}`, params, { responseType: "blob" });
//crop and rotated images
export const rotateImages = params => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.rotateImages}`, params);
export const saveEditedImage = (data, isSurveyAsset) =>
    isSurveyAsset
        ? fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.saveEditedSurveyImage}`, data)
        : fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.saveEditedImage}`, data);
export const restoreEditedImage = (data, isSurveyAsset) =>
    !isSurveyAsset
        ? fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.restoreEditedImage}`, data)
        : fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.restoreEditedSurveyImage}`, data);
export const getImageAnalysisData = data => {
    return fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.getImageAnalysisData}`, data);
};
export const patchImageAnalysisData = data => fcaReportGateway.put(`${serviceEndpoints.imageEndPoints.patchImageAnalysisData}`, data);
export const getAwsRekognition = (params, id) =>
    fcaReportGateway.get(`${serviceEndpoints.imageEndPoints.getAwsRekognition}/${id}/fetch/details/`, { params });
export const getRawImageAnalysisData = data =>
    fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.getAwsRekognition}/raw-image-analysis/`, data);
export const addAnalysedData = data => fcaReportGateway.post(`${serviceEndpoints.imageEndPoints.saveAnalysedData}`, data);
export const imageBulkDownload = data => fcaFastApi.post(`${serviceEndpoints.imageEndPoints.imageBulkDownload}`, data);
export const getImageDownloadProjectsList = params => fcaFastApi.get(`${serviceEndpoints.imageEndPoints.imageDownloadProjectsList}`, {params});
